import { useMutation } from '@tanstack/react-query';
import { releasePortReservation } from '@services/cpqService';

type UseReleasePortReservationOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useReleasePortReservation = ({ onSuccess, onError }: UseReleasePortReservationOptions = {}) => {
  const mutation = useMutation<void, Error, number>({
    mutationFn: (shoppingCartId) => releasePortReservation(shoppingCartId),
    onSuccess,
    onError,
  });

  return {
    release: mutation.mutate,
    releaseAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
};
